import { render, staticRenderFns } from "./publicFooter.vue?vue&type=template&id=5e63e70b&scoped=true"
import script from "./publicFooter.vue?vue&type=script&lang=js"
export * from "./publicFooter.vue?vue&type=script&lang=js"
import style0 from "./publicFooter.vue?vue&type=style&index=0&id=5e63e70b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e63e70b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\01_Projects\\zr_code\\exam_registration_api\\exam-registration-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e63e70b')) {
      api.createRecord('5e63e70b', component.options)
    } else {
      api.reload('5e63e70b', component.options)
    }
    module.hot.accept("./publicFooter.vue?vue&type=template&id=5e63e70b&scoped=true", function () {
      api.rerender('5e63e70b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonality/publicFooter.vue"
export default component.exports